/*
 * @Author: Jordan
 * @Date: 2019-07-24 19:01:46
 * @Last Modified by: Jordan
 * @Last Modified time: 2022-11-29 17:31:25
 */
import { login, loginOut } from '@/api/interface/user'
const app = {
  state: {
    userInfo: null,
    isMobile: false,
    timeDiff: 0,
    uploadParams: null,
    device: null,
    cityName: null, // 所在城市
    longitude: null, // 用户所在纬度
    latitude: null, // 用户所在经度
    publishStatus: 0,
    shareTitle: {},
    shareList: {
      indexM: '庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      indexF: '秦韵华彩庆盛世，群众文化新风尚！',
      newsM: '活动快讯|庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      newsF: '掌握活动实时动态',
      dnkcwM: '看·演出|庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      dnkcwF: '精彩演出线上看',
      dnkcwDetail: '感谢您的点赞与分享',
      jchgM: '观·展览|庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      jchgF: '艺术展览即刻观',
      ysdtM: '赏·非遗|庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      ysdtF: '非遗文化随心赏',
      zacwlistM: '游·陕西|庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      zacwlistF: '大美陕西云享游',
      mapM: '活动地图|庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      mapF: '循迹地域脉络，共庆祖国华诞！',
      actresultM: '精彩瞬间|庆祝中华人民共和国成立75周年陕西省文化馆群众文化活动展播',
      actresultF: '载歌载舞迎华诞，精彩瞬间意隽永！',
      actDetail:'欢迎探索精彩花絮',
      imgUrl: require('../../assets/img/shareicon.png'),
      videoUrl:  'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/5-陕西75周年.mp4',
      coverUrl:'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/5-陕西75周年.png'
    },
    operate: {
      news: 'ffae439b-5ffe-47d5-a862-c4d66a8e54c0',//	群星风采	群星风采-资讯
      likeHistory: '6447e841-0cbf-4818-a477-089857bf08ac-like-history',//	群星风采	群星风采-回
      like23: '6447e841-0cbf-4818-a477-089857bf08ac-like-2023',//群星风采	群星风采-点赞   

    },
    infoList: {
      zppx1: '为全面贯彻党的二十大精神和习近平总书记来陕考察重要讲话重要指示,着力提升全省文化馆 (站)干部运用数字化手段拓展公共文化服务的业务技能和服务水平,推动公共文化服务数字化专业化建设,陕西省文化馆、陕西省群众文化学会特此举办群星风采 •第十届陕西省群文系统业务干部技能(微 课堂)大赛评选活动。',
      zppx2: '参赛作品已经过大赛组委会及省内外相关专家评审委员评定（评定结果详见活动榜单），现针对决赛入围作品，发起线上网络人气作品奖投选，最终推选出3个优秀作品，在主流媒体进行宣推。快来一键参与，为你最喜爱的作品助力吧！',
      zppx3: '1、每个用户可为多个短视频作品点赞助力；',
      zppx4: '2、每个用户每天对同一作品可点赞/助力5次。',
      // zppx5: '3、每个用户每天对同一作品可投5票。',
    },
    fourList: [],
    ewmList: [
      { title: '微信公众号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wx.png'), ewm: require('../../assets/img/wx.jpg') },
      { title: '视频号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/sph.png'), ewm:require('../../assets/img/sphs.jpg')  },
      { title: '官方微博', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wb.png'), ewm: require('../../assets/img/wb.png') },
      { title: 'bilibili', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/B.png'), ewm: require('../../assets/img/bz.png') },
      { title: '官方抖音', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/dy.png'), ewm: require('../../assets/img/dy.jpg') },
      // { title: '快手（认证中）', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/ks.png'), ewm: null },
    ],
    youList: [
      { cover: require('../../assets/img/sjcw/logo1.png'), path: 'http://whhlyt.shaanxi.gov.cn/' },
      { cover: require('../../assets/img/sjcw/logo2.png'), path: 'http://sxswhg.org.cn/' },
      { cover: require('../../assets/img/sjcw/logo3.png'), path: 'http://www.sxggwhy.com/' },
    ],
    classList: [
      
        { value: null, label: '全部' },
        { value: '活动快讯', label: '活动快讯' }, 
        { value: '展览', label: '观·展览' },
        { value: '非遗', label: '赏·非遗' },
        { value: '文旅', label: '游·陕西' },
     
    ],
    areaList: [
      { ocName: '省本级', type: 88 }, 
      { ocName: '西安市', type: 1 },
      { ocName: '铜川市', type: 2 },
      { ocName: '宝鸡市', type: 3 },
      { ocName: '咸阳市', type: 4 },
      { ocName: '渭南市', type: 5 },
      { ocName: '延安市', type: 6 },
      { ocName: '汉中市', type: 7 },
      { ocName: '榆林市', type: 8 },
      { ocName: '安康市', type: 9 },
      { ocName: '商洛市', type: 10 },
    ],
    histList: [
      { ocName: '第一届', English: 'one', title: '群星风采·首届', title1: '陕西省群文干部业务大赛', type: 1, },
      { ocName: '第二届', English: 'two', title: '群星风采·第二届', title1: '陕西省群文干部业务大赛', type: 2, },
      { ocName: '第三届', English: 'three', title: '群星风采·第三届', title1: '陕西省群文干部业务大赛暨全省新编广场舞大赛', type: 3, },
      { ocName: '第四届', English: 'four', title: '群星风采·第四届', title1: '陕西省群文干部业务大赛暨全省群众合唱大赛', type: 4, },
      { ocName: '第五届', English: 'five', title: '群星风采·第五届', title1: '陕西省群文系统业务干部技能大赛', type: 5, },
      { ocName: '第六届', English: 'six', title: '群星风采·第六届', title1: '陕西省群文干部业务大赛', type: 6, },
      { ocName: '第七届', English: null, title: '群星风采·第七届', title1: '陕西省群文系统业务干部（基层文化服务中心）技能大赛', type: 7, },
      { ocName: '第八届', English: null, title: '群星风采·第八届', title1: '陕西省群文系统业务干部技能大赛', type: 8, },
      { ocName: '第九届', English: null, title: '群星风采·第九届', title1: '陕西省群文系统业务干部技能大赛', type: 9, },
    ],
    types: null,
    areaData:null

  },

  mutations: {
    SET_AREADATA: (state, areaData) => {
      state.areaData = areaData
    },
    SET_TYPES: (state, types) => {
      state.types = types
    },
    SET_FOURLIST: (state, fourList) => {
      state.fourList = fourList
    },
    SET_PUBLISHOVER: (state, publishStatus) => {
      state.publishStatus = publishStatus
    },
    SET_SHARELIST: (state, shareList) => {
      state.shareList = shareList
    },
    SET_SHARETITLE: (state, shareTitle) => {
      state.shareTitle = shareTitle
    },
    SET_OPERATECODE: (state, operateCode) => {
      state.operateCode = operateCode
    },
    SET_DEVICE: (state, device) => {
      state.device = device
    },
    SET_POSITION: (state, position) => {
      state.position.latitude = position.latitude
      state.position.longitude = position.longitude
    },
    SET_CITY: (state, cityName) => {
      state.cityName = cityName
    },
    SET_LONGITUDE: (state, longitude) => {
      state.longitude = longitude
    },
    SET_LATITUDE: (state, latitude) => {
      state.latitude = latitude
    },
    SET_MAPDATA: (state, obj) => {
      state.cityName = obj.city
      state.longitude = obj.bounds.northeast.lng
      state.latitude = obj.bounds.northeast.lat
      state.latitude = obj.bounds.northeast.lat
    },
    SET_UPLOADPARAMS: (state, uploadParams) => {
      state.uploadParams = uploadParams
    },
    SET_ISMOBILE: (state, isMobile) => {
      state.isMobile = isMobile
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo
    },
    SET_USERINFOLOGIN: (state, userinfologin) => {
      state.userinfologin = userinfologin
    },
    SET_SYSTIME: (state, timeDiff) => {
      state.timeDiff = timeDiff
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      const { userCode, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ userCode: userCode.trim(), password: password }).then(response => {
          const { data } = response
          commit('SET_USERINFOLOGIN', response.data.data.list[0].user)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户登出
    loginOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then(res => {
          commit('SET_USERINFOLOGIN', null)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js